
import React, { useEffect } from 'react';

// --- ADSENSE CONFIGURATION ---
// 1. Update your Publisher ID (e.g., ca-pub-1234567890)
const ADSENSE_PUBLISHER_ID = 'ca-pub-5403428438107713';
// 2. Update your specific Ad Slot ID
const ADS_SLOT_ID = '7287882868';

export const AdBanner: React.FC = () => {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // Ad blocker likely prevented script load
    }
  }, []);

  return (
    <div className="my-6 w-full max-w-full overflow-hidden">
      <div className="text-center text-[10px] text-slate-600 mb-1 uppercase tracking-widest">Advertisement</div>
      <div className="min-h-[100px] bg-slate-900/50 rounded-lg flex items-center justify-center border border-slate-800/50">
        <ins className="adsbygoogle"
             style={{ display: 'block', width: '100%' }}
             data-ad-client={ADSENSE_PUBLISHER_ID}
             data-ad-slot={ADS_SLOT_ID}
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
      </div>
      <p className="text-[10px] text-slate-600 mt-1 text-center">Slumber Archive is supported by ads</p>
    </div>
  );
};
